import FaqTable from "components/Cards/FaqTable";
import React from "react";

export default function Faq() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <FaqTable />
        </div>
      </div>
    </>
  );
}
